const binding = { modules: {}, dataActions: {} };

    (binding.modules['ext-video-player'] = {
        c: () => require('partner/modules/ext-video-player/ext-video-player.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'ext-video-player',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/ext-video-player'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|ext-video-player|ext-video-player'] = {
                c: () => require('partner/modules/ext-video-player/ext-video-player.view.tsx'),
                cn: '__local__-__local__-ext-video-player'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };